module.exports = __webpack_public_path__ + "static/media/mobilepay-input-dark.ede7f281.svg";